// Packages
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Components
import ListItem from 'modules/Manufacturers/components/ListItem';

// Other
import './styles.css';

const ManufacturerList = ({ isLoading, items, onChange, query }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='ManufacturerList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No manufacturers to show here</h3>
		)
	}


	// Data State
	return (
		<div className='ManufacturerList'>

			{items.map((item, index) => {

				return (
						<Link className='ManufacturerList__link' to={'/manufacturers/' + item.id + (query !== '' ? '?query=' + query : '')} key={index}>
							<ListItem 
								{...item} 
								isLoading={false}
								onChange={() => {onChange()}}
							/>
						</Link>
				)
				
			})}

		</div>
	)
}

ManufacturerList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
	query: PropTypes.string
}

ManufacturerList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
	query: ''
}

export default ManufacturerList;